var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9013 16.6628C10.9013 16.6628 6.15517 13.6822 3.47387 10.2064C1.63497 7.82137 1.02599 5.16851 2.55816 3.22486C4.23248 1.10317 6.5816 0.717133 8.1018 1.16751C10.0035 1.7301 11.0988 3.50317 11.0988 3.50317C11.0988 3.50317 11.9951 1.7301 13.8983 1.16751C15.4185 0.717133 17.7676 1.10167 19.442 3.22486C20.9756 5.16851 20.3651 7.82137 18.5262 10.2064C15.8449 13.6822 10.8998 16.6628 10.8998 16.6628H10.9013Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Heart.defaultProps = {"viewBox":"0 0 22 18","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
